// IELTS Mock 4 — Academic Speaking
// Same shape as IELTS_DATA_SPEAKING in ../IeltsSpeaking.js.
const IELTS_MOCK4_SPEAKING = {
  title: "Academic Speaking Practice Test 4",
  parts: [
    {
      id: "part1",
      title: "Part 1: Introduction & Interview (4-5 min)",
      questions: [
        "Let's talk about where you live. Do you live in a house or an apartment?",
        "What do you like most about the area where you live?",
        "Let's talk about music. What kind of music do you enjoy listening to?",
        "Do you prefer listening to music alone or with other people? Why?",
        "Did you learn to play a musical instrument when you were a child?"
      ]
    },
    {
      id: "part2",
      title: "Part 2: Long Turn (Cue Card) (3-4 min)",
      prompt: "Describe a place you have visited that you would like to go back to. You should say: Where the place is, When you went there and who you went with, What you did there, and explain why you would like to go back.",
      preparationTime: 60,
      speakingTime: 120
    },
    {
      id: "part3",
      title: "Part 3: Discussion (4-5 min)",
      questions: [
        "Why do you think some people prefer to visit the same place again rather than somewhere new?",
        "What are the benefits of tourism for local communities?",
        "Can tourism cause problems for the places that people visit? How could these problems be reduced?",
        "How do you think the way people travel on holiday will change in the future?"
      ]
    }
  ]
};

export default IELTS_MOCK4_SPEAKING;
